import { render, staticRenderFns } from "./ValidationSettingsForm.vue?vue&type=template&id=3028fb4d&scoped=true"
import script from "./ValidationSettingsForm.vue?vue&type=script&lang=js"
export * from "./ValidationSettingsForm.vue?vue&type=script&lang=js"
import style0 from "./ValidationSettingsForm.vue?vue&type=style&index=0&id=3028fb4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3028fb4d",
  null
  
)

export default component.exports